'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { OrderedMap, OrderedSet } from 'immutable';
import partial from 'transmute/partial';
import SearchSortRecord from 'SalesContentIndexUI/data/records/SearchSortRecord';
import { TableActionsRow } from 'foundations-components/transitional/components/Table';
import IndexTableHeaderCell from './IndexTableHeaderCell';
import IndexTableHeaderCheckboxCell from './IndexTableHeaderCheckboxCell';
import SearchContentTypePropType from '../propTypes/SearchContentTypePropType';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class IndexTableHeader extends Component {
  constructor(...args) {
    super(...args);
    this.shouldOpenActionsRow = () => {
      const {
        selectedFolders,
        selectedRows
      } = this.props.selectionData;
      return !selectedFolders.isEmpty() || !selectedRows.isEmpty();
    };
    this.toggleAllIndividualResults = () => {
      const {
        folderContentType,
        searchResults,
        selectionData,
        toggleRowSelection
      } = this.props;
      searchResults.filter(({
        contentType
      }) => folderContentType !== contentType).filter(searchResult => {
        // If none are selected then we toggle all (turn all on)
        // Otherwise we toggle only the ones selected (turn all off)
        return selectionData.selectedRows.size === 0 || selectionData.selectedRows.has(searchResult.get('contentId'));
      }).forEach(toggleRowSelection);
    };
    this.areAllIndividualResultsSelected = () => {
      const {
        folderContentType,
        searchResults,
        selectionData
      } = this.props;
      let allSelected = true;
      searchResults.filter(({
        contentType
      }) => folderContentType !== contentType).forEach(searchResult => {
        allSelected = allSelected && selectionData.selectedRows.has(searchResult.get('contentId'));
      });
      return allSelected;
    };
    this.renderActionButtons = () => {
      const {
        renderFolderTableActionButtons,
        renderSearchResultTableActionButtons,
        selectionData
      } = this.props;
      const {
        selectedFolders,
        selectedRows
      } = selectionData;
      const foldersSelected = !selectedFolders.isEmpty();
      const rowsSelected = !selectedRows.isEmpty();
      if (!foldersSelected && !rowsSelected) {
        return /*#__PURE__*/_jsx("div", {});
      }
      const selectedSize = Math.max(selectedFolders.size, selectedRows.size);
      const renderActionButtons = foldersSelected ? partial(renderFolderTableActionButtons, selectedFolders) : partial(renderSearchResultTableActionButtons, selectedRows);
      return /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsxs(Flex, {
          children: [/*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "salesContentIndexUI.tableActionButtons.selectedCount",
              options: {
                selectedSize
              }
            })
          }), renderActionButtons()]
        })
      });
    };
    this.renderCheckboxCell = () => {
      const {
        isModal,
        folderContentType,
        selectionData,
        searchResults
      } = this.props;
      if (isModal) {
        return null;
      }
      const hasIndividualContent = searchResults.filter(searchResult => {
        // Filter to only individual results
        const {
          contentType
        } = searchResult;
        return folderContentType !== contentType;
      }).size > 0;
      return /*#__PURE__*/_jsx(IndexTableHeaderCheckboxCell, {
        checked: hasIndividualContent && this.areAllIndividualResultsSelected(),
        disabled: selectionData.selectedFolders.size > 0 || !hasIndividualContent,
        folderContentType: folderContentType,
        indeterminate: selectionData.selectedRows.size > 0,
        toggleSelection: this.toggleAllIndividualResults
      });
    };
    this.renderHeaderCells = () => {
      const {
        tableColumns,
        currentSort,
        setSort
      } = this.props;
      return tableColumns.map(columnData => {
        return /*#__PURE__*/_jsx(IndexTableHeaderCell, {
          columnData: columnData,
          currentSort: currentSort,
          setSort: setSort
        }, `index.list.table.${columnData.id}`);
      }).toList();
    };
  }
  render() {
    return /*#__PURE__*/_jsx("thead", {
      "data-test-id": "sales-content-index-table-header",
      children: /*#__PURE__*/_jsxs(TableActionsRow, {
        open: this.shouldOpenActionsRow(),
        openAtColumnIndex: 1,
        actions: this.renderActionButtons(),
        children: [this.renderCheckboxCell(), this.renderHeaderCells()]
      })
    });
  }
}
IndexTableHeader.propTypes = {
  currentSort: PropTypes.instanceOf(SearchSortRecord),
  tableColumns: PropTypes.instanceOf(OrderedSet).isRequired,
  renderFolderTableActionButtons: PropTypes.func,
  renderSearchResultTableActionButtons: PropTypes.func,
  selectionData: PropTypes.object.isRequired,
  setSort: PropTypes.func.isRequired,
  toggleRowSelection: PropTypes.func.isRequired,
  folderContentType: SearchContentTypePropType,
  searchResults: PropTypes.instanceOf(OrderedMap).isRequired,
  isModal: PropTypes.bool.isRequired
};